import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getHousekeepingApplicationMasterList_action, deleteHousekeepingApplicationMaster_action, insertUpdateHousekeepingApplicationMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/housekeeping_application_master_action'
import { fill_action } from '../../../../../actions/fillCombo_action'
import { BASE_URL, countryActionId, toastError, toastSuccess, visaIdTypeActionId } from "../../../../../utils/constants";
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import Passport_Front_1008_VIS_903747 from "../../../../../files/Passport_Front_1008_VIS_903747.jpeg"

class HousekeepingApplicationMasterAU extends Component {

    // initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            editID: null,
            // fields
            BankName: '',
            BankAddress: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            AccountNumber: '',
            SwiftCode: '',
            IFSCCodeValue: '',
            PANNumber: '',
            GSTNumber: '',
            Name: "",
            Address: "",
            Phone: '',
            Mobile: '',
            Fax: '',
            PrimaryEmail: '',
            SecondaryEmail: '',
            // List
            HousekeepingApplicationList: [],
            BankNameErr: '',
            BankAddressErr: '',
            BeneficiaryNameErr: '',
            BeneficiaryAddressErr: '',
            AccountNumberErr: '',
            SwiftCodeErr: '',
            IFSCCodeValueErr: '',
            PANNumberErr: '',
            GSTNumberErr: '',
            NameErr: "",
            AddressErr: "",
            MobileErr: '',
            PrimaryEmailErr: '',
            SecondaryEmailErr: '',
            index: 1,
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        // this.getFillList = this.getFillList.bind(this)
        this.renderHousekeepingApplicationList = this.renderHousekeepingApplicationList.bind(this)
        // this.onFilePick = this.onFilePick.bind(this)
        // this.onPdfSelect = this.onPdfSelect.bind(this)
        // this.resizeFile = this.resizeFile.bind(this)
        this.handleAddMore = this.handleAddMore.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
        // this.handleUpdate = this.handleUpdate.bind(this)
        // this.getDetails = this.getDetails.bind(this)
        // this.emailValidation = this.emailValidation.bind(this)
        // this.onCrossClick = this.onCrossClick.bind(this)
        // this.mobileValidation = this.mobileValidation.bind(this)
        // this.onDocDelete = this.onDocDelete.bind(this)
        // this.handleDelete = this.handleDelete.bind(this)
    }

    componentDidMount() {
        const locState = this.props.location.state
        const editData = locState && locState.editData ? locState.editData : null
        if (editData) {
            this.setState({
                Name: editData.Name || '', Address: editData.Address || '',
                Phone: editData.Phone || '', Mobile: editData.Mobile || '',
                Fax: editData.Fax || '', PrimaryEmail: editData.PrimaryEmail || '',
                SecondaryEmail: editData.SecondaryEmail || '',
                BankName: editData.BankName || '', BankAddress: editData.BankAddress || '',
                BeneficiaryName: editData.BeneficiaryName || '', BeneficiaryAddress: editData.BeneficiaryAddress || '',
                AccountNumber: editData.AccountNumber || '', SwiftCode: editData.SwiftCode || '',
                IFSCCodeValue: editData.IFSCCodeValue || '', PANNumber: editData.PANNumber || '',
                GSTNumber: editData.GSTNumber || '',
                editID: editData.HousekeepingContactPersonID || null,
            })
        }
        this.getHousekeepingApplicationMasterList(editData ? editData.HousekeepingContactPersonID : null)
    }

    // On cancel Click
    OnCancel() {
        this.props.navigate('/HousekeepingApplicationMasterList')
    }
    getHousekeepingApplicationMasterList(editID) {
        this.setState({ isLoading: true })
        this.props.getHousekeepingApplicationMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    let list = data.data[0] || []
                    if (editID) {
                        list = list.filter(r => r.HousekeepingContactPersonID !== editID)
                    }
                    list = list.map((r, i) => ({ ...r, isShow: true, index: i + 1 }))
                    this.setState({ HousekeepingApplicationList: list, index: list.length + 1, isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    // Input Fields Validation
    inputValidate() {
        const { BankName, BankAddress, BeneficiaryName, BeneficiaryAddress, AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber, Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail } = this.state
        if (Name == "") {
            this.setState({ NameErr: "Please Enter Name" })
        }
        if (Mobile == "") {
            this.setState({ MobileErr: "Please Enter Mobile No." })
        }
        if (PrimaryEmail == "") {
            this.setState({ PrimaryEmailErr: "Please Enter Primary Email" })
        } else {
            var PEmailerr = (emailValidator(PrimaryEmail) == '') ? false : emailValidator(PrimaryEmail)
            if (PEmailerr) {
                this.setState({ PrimaryEmailErr: "Please Enter Proper Primary Email" })
            }
        }
        if (SecondaryEmail != "" && SecondaryEmail != null) {
            var SEmailerr = (emailValidator(SecondaryEmail) == '') ? false : emailValidator(SecondaryEmail)
            if (SEmailerr) {
                this.setState({ SecondaryEmailErr: "Please Enter Proper Secondary Email" })
            }
        }
    }

    renderHousekeepingApplicationList() {
        const { HousekeepingApplicationList } = this.state
        return (
            <ul class="list-group " style={{ position: 'relative', zIndex: 1 }}>
                {
                    HousekeepingApplicationList.length > 0 && HousekeepingApplicationList.map((data, index) => (
                        data.isShow &&
                        <li class="list-group-item" key={Math.random()}>
                            <div className="added-more p-3 rounded-2">
                                <h5 style={{ color: "#0056ff" }}>Added Housekeepiing Application Master {data.index}</h5>
                                <h6 >Agency Contact </h6>
                                <div className="row mt-4">
                                    <div className="col-md-3">
                                        <h6>Name: {data.Name}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Mobile no.: {data.Mobile}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Address: {data.Address}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <h6>Telephone: {data.Phone}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Fax: {data.Fax}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Primary Email: {data.PrimaryEmail}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Secondary Email: {data.SecondaryEmail}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr className="m-1" />
                            <div className="added-more p-3 rounded-2">
                                <h6>Bank Details </h6>
                                <div className="row mt-4">
                                    <div className="col-md-3">
                                        <h6>Bank Name: {data.BankName}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Bank Address: {data.BankAddress}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Account Number: {data.AccountNumber}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <h6>Beneficiary Name: {data.BeneficiaryName}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Beneficiary Address: {data.BeneficiaryAddress}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Swift Code: {data.SwiftCode}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <h6>IFSC Code: {data.IFSCCodeValue}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>PAN Number: {data.PANNumber}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>GST Number: {data.GSTNumber}</h6>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        )
    }

    handleAddMore() {
        const {
            BankName, BankAddress, BeneficiaryName, BeneficiaryAddress, AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber, Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, NameErr, AddressErr, MobileErr, PrimaryEmailErr, SecondaryEmailErr,
        } = this.state
        this.inputValidate()
        if (Name != '' && Mobile != "" && PrimaryEmail != "") {
            if (NameErr == '' && MobileErr == '' && PrimaryEmailErr == '' && SecondaryEmailErr == '') {
                const entry = [{
                    BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
                    AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber,
                    Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
                }]
                this.setState({ isLoading: true })
                this.props.insertUpdateHousekeepingApplicationMaster_action(entry)
                    .then((data) => {
                        if (data.error != 1) {
                            toastSuccess("Record Added Successfully")
                            setTimeout(() => {
                                this.setState({ isLoading: false })
                                this.props.navigate('/HousekeepingApplicationMasterList')
                            }, 300)
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
            else {
                toastError('Please enter proper fields')
            }
        }
        else {
            toastError('Please enter mandatory fields')
        }
    }

    handleSave() {
        const { HousekeepingApplicationList, editID, Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, BankName, BankAddress, BeneficiaryName, BeneficiaryAddress, AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber } = this.state

        const isFormEmpty = !Name && !Address && !Mobile && !PrimaryEmail

        // If the form is empty (user clicked Add More and doesn't want to add another),
        // save only the already-added list entries
        if (isFormEmpty) {
            if (HousekeepingApplicationList.length === 0) {
                toastError('Please enter mandatory fields')
                return
            }
            // proceed with only the list entries
            this.setState({ isLoading: true })
            this.props.insertUpdateHousekeepingApplicationMaster_action(HousekeepingApplicationList)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Record Added Successfully")
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                            this.props.navigate('/HousekeepingApplicationMasterList')
                        }, 300);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.setState({ isLoading: false })
                })
            return
        }

        // Form has data — validate before including it in the save
        this.inputValidate()
        if (!Name || !Mobile || !PrimaryEmail) {
            toastError('Please enter mandatory fields')
            return
        }

        // In edit mode, include the current form data (the record being edited)
        // along with all other existing records
        const currentFormEntry = {
            Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
            BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
            AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber,
        }
        const listToSave = [currentFormEntry, ...HousekeepingApplicationList]

        this.setState({ isLoading: true })
        this.props.insertUpdateHousekeepingApplicationMaster_action(listToSave)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Record Added Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.props.navigate('/HousekeepingApplicationMasterList')
                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    ClearValue() {
        this.setState({
            BankName: '',
            BankAddress: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            AccountNumber: '',
            SwiftCode: '',
            IFSCCodeValue: '',
            PANNumber: '',
            GSTNumber: '',
            Name: "",
            Address: "",
            Phone: '',
            Mobile: '',
            Fax: '',
            PrimaryEmail: '',
            SecondaryEmail: '',
            index: this.state.index + 1
        })
    }

    render() {
        const { isLoading, editID, BankName, BankAddress, BankAddressErr, BeneficiaryName, HousekeepingApplicationList, BeneficiaryAddress, AccountNumber, SwiftCode, IFSCCodeValue, PANNumber, GSTNumber, Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, BankNameErr, BeneficiaryNameErr, BeneficiaryAddressErr, AccountNumberErr, SwiftCodeErr, IFSCCodeValueErr, PANNumberErr, GSTNumberErr, NameErr, AddressErr, MobileErr, PrimaryEmailErr, SecondaryEmailErr,
        } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Houserkeeping Application Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 pt-0">

                                <div
                                    className="card-header p-2"
                                    style={{ paddingLeft: "7px !important" }}
                                >
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Agency contact
                                    </h3>
                                </div>
                                <div className="card-body p-2 mt-1">
                                    <div className="row">
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Name<span className="text-red">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={Name}
                                                onChange={(e) => this.setState({ Name: e.target.value, NameErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}

                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Mobile No.<span className="text-red">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                placeholder="Use / to separate multiple numbers"
                                                value={Mobile}
                                                onChange={(e) => this.setState({ Mobile: e.target.value, MobileErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{MobileErr}</span>}

                                        </div>
                                        <div className="col-xl-6">
                                            <label htmlFor="validationCustom03">
                                                Address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={Address}
                                                onChange={(e) => this.setState({ Address: e.target.value, AddressErr: '' })}
                                            />

                                            {<span className='text-danger text-start text-left d-block mt-1'>{AddressErr}</span>}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Telephone
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                placeholder="Use / to separate multiple numbers"
                                                value={Phone}
                                                onChange={(e) => this.setState({ Phone: e.target.value, })}
                                            />
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Fax
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                placeholder="Use / to separate multiple numbers"
                                                value={Fax}
                                                onChange={(e) => this.setState({ Fax: e.target.value, })}
                                            />
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">Primary Email<span className="text-red">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={PrimaryEmail}
                                                onChange={(e) => this.setState({ PrimaryEmail: e.target.value, PrimaryEmailErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{PrimaryEmailErr}</span>}
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">Secondary Email</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={SecondaryEmail}
                                                onChange={(e) => this.setState({ SecondaryEmail: e.target.value, SecondaryEmailErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{SecondaryEmailErr}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="">
                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Bank Details
                                        </h3>
                                    </div>
                                    <div className="card-body p-2 mt-1">
                                        <div className="row">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Bank Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BankName}
                                                    onChange={(e) => this.setState({ BankName: e.target.value, BankNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{BankNameErr}</span>}

                                            </div>
                                            <div className="col-xl-6">
                                                <label htmlFor="validationCustom03">
                                                    Bank Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BankAddress}
                                                    onChange={(e) => this.setState({ BankAddress: e.target.value, BankAddressErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{BankAddressErr}</span>}

                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Account Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={AccountNumber}
                                                    onChange={(e) => this.setState({ AccountNumber: e.target.value, AccountNumberErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{AccountNumberErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Beneficiary Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BeneficiaryName}
                                                    onChange={(e) => this.setState({ BeneficiaryName: e.target.value, BeneficiaryNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{BeneficiaryNameErr}</span>}

                                            </div>
                                            <div className="col-xl-6">
                                                <label htmlFor="validationCustom03">
                                                    Beneficiary Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BeneficiaryAddress}
                                                    onChange={(e) => this.setState({ BeneficiaryAddress: e.target.value, BeneficiaryAddressErr: '' })}
                                                />

                                                {<span className='text-danger text-start text-left d-block mt-1'>{BeneficiaryAddressErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Swift Code
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={SwiftCode}
                                                    onChange={(e) => this.setState({ SwiftCode: e.target.value, SwiftCodeErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{SwiftCodeErr}</span>}

                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">IFSC Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={IFSCCodeValue}
                                                    onChange={(e) => this.setState({ IFSCCodeValue: e.target.value, IFSCCodeValueErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{IFSCCodeValueErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">PAN Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={PANNumber}
                                                    onChange={(e) => this.setState({ PANNumber: e.target.value, PANNumberErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{PANNumberErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">GST Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={GSTNumber}
                                                    onChange={(e) => this.setState({ GSTNumber: e.target.value, GSTNumberErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{GSTNumberErr}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-2 save-can d-block">
                                    {!this.state.editID && (
                                        <div className="text-end mt-2" role="group" aria-label="Basic example">
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.handleAddMore()}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    )}

                                    <div className="row mt-2">
                                        <div className="text-end" role="group" style={{ float: 'right' }} aria-label="Basic example">
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.handleSave()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-gray ms-2"
                                                onClick={() => this.OnCancel()}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </>
            </>
        )
    }
}
export default withRouter(connect(null, { getHousekeepingApplicationMasterList_action, deleteHousekeepingApplicationMaster_action, insertUpdateHousekeepingApplicationMaster_action, fill_action })(HousekeepingApplicationMasterAU))